/**
 * SINGLE SOURCE OF TRUTH for the homepage product collections.
 *
 * A "collection" is a curated storefront slot reached via /catalog?filter=<value>
 * and interpreted by the server's GET /api/products. This list is consumed by
 * BOTH:
 *   - the React storefront (HomePage hero slides, MidNavBar active-filter label,
 *     CatalogPage heading) — imported directly since it lives under src/, and
 *   - the Node backend (server/index.js) — required as a CommonJS module to know
 *     which filter values are collections (vs plain catalog filters).
 *
 * The CRM portal's Express server also serves this exact file at
 * /shared/homepageCollections.js (globalThis.AbhirasHomepageCollections), mirroring
 * productTags.js. Edit this file only; every app follows it.
 *
 * Each entry's `value` is the exact ?filter= string the backend branches on; keep
 * it in step with server/index.js. `label` is the display name shown in the UI.
 * The ORDER here is the order the hero slides rotate in.
 */

(function (root, factory) {
  const api = factory();
  // CommonJS (the storefront Node server reads this)
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  // Browser global (CRM portal reads this off the window, like the other shared files)
  if (typeof globalThis !== 'undefined') {
    globalThis.AbhirasHomepageCollections = api;
  }
})(this, function () {
  // Order = hero-slide rotation order on the homepage.
  const HOMEPAGE_COLLECTIONS = [
    { value: 'top_picks', label: 'Top Picks' },
    { value: 'new_arrivals', label: 'New Arrivals' },
    { value: 'high_discounts', label: 'High Discounts' },
    { value: 'seasonal', label: 'Seasonal Picks' },
    { value: 'buy_again', label: 'Buy Again' },
    { value: 'gifts', label: 'Gifts' },
  ];

  /** Just the collection filter values, in order. */
  function collectionValues() {
    return HOMEPAGE_COLLECTIONS.map((collection) => collection.value);
  }

  /** True when a ?filter= value is a homepage collection (vs a catalog filter). */
  function isCollection(value) {
    const v = String(value === null || value === undefined ? '' : value).toLowerCase();
    return HOMEPAGE_COLLECTIONS.some((collection) => collection.value === v);
  }

  /** value -> label. Unknown values map to themselves (never throws). */
  function labelFor(value) {
    const v = String(value === null || value === undefined ? '' : value);
    const found = HOMEPAGE_COLLECTIONS.find((collection) => collection.value === v.toLowerCase());
    return found ? found.label : v;
  }

  return {
    HOMEPAGE_COLLECTIONS,
    collectionValues,
    isCollection,
    labelFor,
  };
});
